// for conditional object with options or just options
export const returnSelectOptions = (props: { options: string[]; label?: string } | string[]) => {
  let options: string[] = [];

  if (Array.isArray(props)) {
    options = props;
  } else if (Array.isArray(props?.options)) {
    options = props.options;
  }

  return (
    options.map((item: any) => {
      return { name: item, value: item };
    }) ?? []
  );
};

// for conditional object with label or just default label
export const returnSelectLabel = (
  props: { options: string[]; label?: string } | string[],
  defaultLabel: string
) => {
  if (!Array.isArray(props) && props?.label) {
    return props?.label;
  }
  return defaultLabel;
};
